import { ConfirmModal } from '../ConfirmModal/ConfirmModal';
import { Button } from '../Button/Button';
import type { CustomerSummary } from '../../../types/api';
import styles from './DuplicateCustomerWarning.module.css';

export interface DuplicateCustomerWarningProps {
  matches: CustomerSummary[];
  showConfirm: boolean;
  onUseExisting: (customer: CustomerSummary) => void;
  onCreateAnyway: () => void;
  onDismiss: () => void;
  onConfirmCreate: () => void;
  onCancelConfirm: () => void;
}

export function DuplicateCustomerWarning({
  matches,
  showConfirm,
  onUseExisting,
  onCreateAnyway,
  onDismiss,
  onConfirmCreate,
  onCancelConfirm,
}: DuplicateCustomerWarningProps): JSX.Element {
  return (
    <>
      <div className={styles.panel} role="alert">
        <div className={styles.header}>
          <span className={styles.title}>Similar customers found</span>
          <button
            type="button"
            className={styles.dismiss}
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
        <ul className={styles.list}>
          {matches.map((m) => (
            <li key={m.uuid} className={styles.row}>
              <span className={styles.name}>{m.name}</span>
              {m.phone && <span className={styles.meta}>{m.phone}</span>}
              {m.postcode && <span className={styles.meta}>{m.postcode}</span>}
              <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={() => onUseExisting(m)}
              >
                Use this customer
              </Button>
            </li>
          ))}
        </ul>
        <div className={styles.footer}>
          <button type="button" className={styles.createAnyway} onClick={onCreateAnyway}>
            Create new customer anyway
          </button>
        </div>
      </div>
      <ConfirmModal
        open={showConfirm}
        title="Similar customer exists"
        message="A similar customer already exists. Create a new customer record anyway?"
        confirmLabel="Yes, create new"
        cancelLabel="Cancel"
        onConfirm={onConfirmCreate}
        onCancel={onCancelConfirm}
      />
    </>
  );
}
